module.exports = __webpack_public_path__ + "static/bg2-415a9e958be6f3fc1b8f28b522922584.png";